module.exports = __webpack_public_path__ + "img/DerAufprall4.d90a78c9.jpg";